import React from 'react';
import FormField from 'parent-portal/forms/components/FormField';
import Input from 'reusableComponents/input';
import { Colors } from 'library';

export default function TextInput({
    label,
    value,
    onChange,
    error,
    helperText,
    multiline = true,
}: {
    label: string;
    value: string;
    onChange: (value: string) => void;
    error?: boolean;
    helperText?: string;
    multiline?: boolean;
}) {
    return (
        <FormField title={label} titleStyle={{ color: Colors.darkNavy }}>
            <Input
                error={error}
                helperText={helperText}
                fullWidth
                style={{ marginBottom: 0 }}
                value={value}
                onChange={(e) => onChange(e.target.value)}
                multiline={multiline}
                InputLabelProps={{ shrink: true }}
            />
        </FormField>
    );
}
